import { ObjectValues } from 'helpers/types';

export const PAYMENT_STATUS = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
} as const;

export type IPaymentStatusType = ObjectValues<typeof PAYMENT_STATUS>;

export interface IPaymentHistoryEntity {
  operationId: string;
  status: IPaymentStatusType;
  receipt: string;
  order: {
    number: string;
    subscription: {
      name: string;
      code: string;
      price: number;
      currency: string;
      endDate: number;
    };
  };
  paymentMethod: {
    brand: string;
    last4: string;
    expirationMonth: number;
    expirationYear: number;
  };
  createdAt: Date;
  updatedAt: Date;
}

export interface ISortEntity {
  sorted: boolean;
  empty: boolean;
  unsorted: boolean;
}

export const PAYMENT_METHODS = {
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  AMERICAN_EXPRESS: 'amex',
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
} as const;

export type IPaymentMethodsType = ObjectValues<typeof PAYMENT_METHODS>;
